import { store } from '@/store/store'

import Layout from '@/container/Full'
import CancelView from '@/views/cancel/CancelView'
import CancellationDetailView from 'Views/cancellations/CancellationDetailView'
import { ExternalLinks } from '@/consts/main'

const routes = [
  {
    path: '/cancel',
    name: '',
    component: Layout,
    beforeEnter: (to, from, next) => {
      if (!to.params.service_id) {
        window.location.href = ExternalLinks.GG_CANCELLATION_KB

        return
      }
      store.commit('CLEAR_CANCEL_STORE')
      next()
    },
    children: [
      {
        path: ':service_id?',
        name: 'cancel',
        component: CancelView,
        meta: {
          access_type: 'authorized',
        },
      },
    ]
  },
  {
    path: '/cancellations',
    name: '',
    component: Layout,
    children: [
      {
        path: ':id?',
        name: 'cancellation',
        component: CancellationDetailView,
        beforeEnter: (to, from, next) => {
          if (!to.params.id) {
            console.log(`Параметр - ${to.params.id}`)
            next('/')
          } else {
            console.log(`Параметр - ${to.params.id}`)
            console.log()
            next()
          }
        },
        meta: {
          access_type: 'authorized',
          breadcrumb: routeParams => `#${routeParams.id}`,
        },
      }
    ]
  }
]

export default routes
